import React from 'react';

import { List } from './styles';
import { display } from 'components/ErrorView/ErrorDialog';

interface IInfiniteListProps {
  onLoadMore: () => Promise<void>;
  children?: React.ReactNode;
}

interface IInfiniteListStates {
  loading: boolean;
  loadMoreButton: boolean;
}

class InfiniteList extends React.PureComponent<
  IInfiniteListProps,
  IInfiniteListStates
> {
  state = {
    loading: true,
    loadMoreButton: false,
  };

  async componentDidMount() {
    await this.props
      .onLoadMore()
      .then(() => {
        this.setState({ loading: false });
      })
      .catch((err: any) => {
        display(err);
        this.setState({ loading: false });
      });
    window.addEventListener('scroll', this.handleOnScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll = () => {
    const scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    const scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    const clientHeight =
      (document.documentElement && document.documentElement.clientHeight) ||
      window.innerHeight;
    const scrolledToBottom =
      Math.ceil(scrollTop + clientHeight) >= scrollHeight;
    if (scrolledToBottom) {
      if (!this.state.loading) {
        this.loadData();
      }
    }
  };

  loadData = () => {
    this.setState({ loading: true });
    this.props
      .onLoadMore()
      .then(() => {
        this.setState({ loading: false, loadMoreButton: false });
      })
      .catch(() => {
        this.setState({ loadMoreButton: true });
      });
  };

  render() {
    return (
      <List>
        {this.props.children}
        {this.state.loading && (
          <div className="progress">
            <div className="indeterminate" />
          </div>
        )}
      </List>
    );
  }
}

export default InfiniteList;
